import { createSelector } from 'reselect';

const userSelector = state => state.user;

export const userConfigSelector = createSelector(
  userSelector,
  user => user.userConfig
);

export const selectIsShowApiKeys = createSelector(
  [userConfigSelector],
  userConfig => {
    const isShowApiKeys = userConfig.find(item => item.Key === 'isShowApiKeys');
    if (isShowApiKeys) {
      return JSON.parse(isShowApiKeys.Value);
    } else {
      return false;
    }
  }
);
